import api from '@/services/api';

export default {
  async getMarketRentSummary(budgetIterationId, includeHistoricals) {
    try {
      let response = await api.get(`MarketRent/Summary?budgetIterationId=${ budgetIterationId }&includeHistoricals=${ includeHistoricals || false }`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  // Base Rent
  async getBaseRentEntries(budgetIterationId) {
    try {
      let response = await api.get(`MarketRent/BaseRent?budgetIterationId=${budgetIterationId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async resetBaseRentEntries(budgetIterationId, lastModifiedTimestamp) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.post('MarketRent/BaseRent/Defaults', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  // Renovations
  async getRenovationsEntries(budgetIterationId) {
    try {
      let response = await api.get(`MarketRent/Renovations?budgetIterationId=${budgetIterationId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async resetRenovationsEntries(budgetIterationId, lastModifiedTimestamp) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.post('MarketRent/Renovations/Defaults', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  // Amenities
  async getAmenitiesEntries(budgetIterationId) {
    try {
      let response = await api.get(`MarketRent/Amenities?budgetIterationId=${budgetIterationId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async resetAmenitiesEntries(budgetIterationId, lastModifiedTimestamp) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.post('MarketRent/Amenities/Defaults', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
}
